<div class="cards-container">
  <vantage-platform-card
    class="m-0"
    [card]="card"
    [config]="getCardConfig(card)"
  ></vantage-platform-card>
</div>
